import React from 'react';
import { useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  
  // Detectar si es localhost o producción
  let subdomain = null;
  if (hostname === 'localhost') {
    subdomain = null;
  } else if (hostname.endsWith('.localhost')) {
    subdomain = parts[0];
  } else if (parts.length > 2) {
    subdomain = parts[0];
  }

  // Si hay subdominio y la ruta no es la raíz, mostrar mensaje específico
  if (subdomain && location.pathname !== '/') {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        textAlign: 'center'
      }}>
        <h2 style={{
          fontSize: '24px',
          marginBottom: '20px',
          color: '#333'
        }}>Acceso no permitido</h2>
        <p style={{
          fontSize: '16px',
          color: '#666',
          marginBottom: '30px'
        }}>La ruta {location.pathname} no está disponible.</p>
      </div>
    );
  }

  // Mensaje de error genérico para otras situaciones
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5',
      textAlign: 'center'
    }}>
      <h2 style={{
        fontSize: '24px',
        marginBottom: '20px',
        color: '#333'
      }}>Página no encontrada</h2>
      <p style={{
        fontSize: '16px',
        color: '#666',
        marginBottom: '30px'
      }}>Lo sentimos, la página que estás buscando no existe.</p>
    </div>
  );
}